export default {
  login: 'pt/api/Account/Login/',
  refreshToken: 'pt/api/Account/RefreshToken',
  getUsers: 'pt/api/BackOfficeUsers/',
  getListBackOfficeUsers: 'pt/api/BackOfficeUsers/GetListBackOfficeUsers',
  getRoles: 'pt/api/BackOfficeUsers/Roles/',
  createUsers: 'pt/api/BackOfficeUsers/',
  deleteUser: 'pt/api/BackOfficeUsers/',
  disableUser: 'pt/api/BackOfficeUsers/Disable/',
  enableUser: 'pt/api/BackOfficeUsers/Enable/',
  getTranshipment: 'pt/api/ManageTranshipments/',
  getSummaryDataTranshipment: 'pt/api/ManageTranshipments/SummaryData',
  getStates: 'pt/api/States/',
  getCities: 'pt/api/States/Cities/',
  createTranshipmentPersonal: 'pt/api/TranshipmentPhysicalPersons/',
  createTranshipment: 'pt/api/TranshipmentJuridicalPersons/',
  disableTranshipment: 'pt/api/ManageTranshipments/Disable/',
  enableTranshipment: 'pt/api/ManageTranshipments/Enable/',
  deleteTranshipment: 'pt/api/ManageTranshipments/',
  getCouriers: 'pt/api/ManageDirectDeliverers/',
  getSummaryData: 'pt/api/ManageDirectDeliverers/SummaryData/',
  getVehiclesTypes: 'pt/api/DomainEntities/TypeVehicles/',
  getTypeDocumentPhotos: 'pt/api/DomainEntities/TypeDocumentPhotos/',
  createCouriers: 'pt/api/ManageDirectDeliverers/',
  disableCouriers: 'pt/api/ManageDirectDeliverers/Disable/',
  enableCouriers: 'pt/api/ManageDirectDeliverers/Enable/',
  transhipmentNegotiationsCityByID: 'pt/api/NegotiationsCity/',
  transhipmentNegotiationsCNPJByID: 'pt/api/NegotiationsCpfOrCnpj/',
  transhipmentNegotiationsWeightDelivery: 'pt/api/NegotiationsCityWeightDelivery/',
  transhipmentNegotiationsCpfOrCnpjWeightDelivery: 'pt/api/NegotiationsCpfOrCnpjWeightDelivery/',
  getShipment: 'pt/api/BoardingImports/',
  approveSheet: 'pt/api/BoardingImports/Approve/',
  discartSheet: 'pt/api/BoardingImports/Discard/',
  getManifest: 'pt/api/IntegrationEsl',
  getManifestById: 'pt/api/IntegrationEsl/GetById/',
  getNewManifest: 'pt/api/IntegrationEsl/BoadingImportIntegrationEsl',
  approveImportManifest: 'pt/api/IntegrationEsl/Approve/',
  discartImportManifest: 'pt/api/IntegrationEsl/Discard/',
  getTranshipmentBetweenDeliverers: 'pt/api/TransferBetweenTranshipments/TranshipmentDeliverers/',
  getTranshipmentBetweenStops: 'pt/api/TransferBetweenTranshipments/StopsByTranshipment/',
  getDeliveriesPending: 'pt/api/Deliveries/DeliveriesPending/',
  getManegementShipments: 'pt/api/Boardings/',
  getManegementShipmentsCargos: 'pt/api/Cargos/',
  getManegementShipmentsStops: 'pt/api/Stops/',
  getManegementShipmentsDeliveries: 'pt/api/Deliveries/',
  getManegementShipmentsNFE: 'pt/api/Nfes/',
  getFastManegementShipmentsNFE: 'pt/api/Nfes/GetNfesByBoarding/',
  getDirectDeliverer: 'pt/api/DirectDeliverer/Details',
  getStatusShipment: 'pt/api/BoardingImports/Status/',
  transferDataDeliverers: 'pt/api/TransferBetweenTranshipments/TransferDeliverers/',
  getSheetPackages: 'pt/api/Packages/ManyAccessKey/',
  getSheetPackagesNfe: 'pt/api/Packages/OneAccessKey/',
  editShipment: 'pt/api/Boardings/',
  transferStops: 'pt/api/TransferBetweenTranshipments/TransferHierarchy',
  getNfeById: 'pt/api/Nfes/GetById/',
  getNfesByStopId: 'pt/api/Nfes/GetNfesByStopId?stopId=',
  getNfe: 'pt/api/Nfes/',
  getStatusNfe: 'pt/api/Status/',
  getJustificationsTypesNfe: 'pt/api/JustificationTypes/',
  getJustificationsNfe: 'pt/api/Justifications/',
  statusManagerBKO: 'pt/api/StatusManagerBackOffices/ChangeStatus/',
  changeStatusManagerBKO: 'pt/api/StatusManagerBackOffices/ChangeStatusManagement/',
  getStopByStatus: 'pt/api/Stops/StopsByStatusId',
  getManageTranshipmentDeliverersSummary: 'pt/api/ManageTranshipmentDeliverers/SummaryData',
  getDeliveriesDetails: 'pt/api/Deliveries/DeliveriesDetailsByStop/',
  updateCallNumberQuarantine: 'pt/api/Nfes/SetQuarantineCallNumber/',
  getCallNumberQuarantine: 'pt/api/Nfes/GetQuarantineCallNumber/',
  moveDeliveryQuarantine: 'pt/api/BackOfficeUsers/MoveDeliveryQuarantine/',
  receiptNfe: 'pt/api/ReceiptsNfe/',
  moveTransferQuarantine: 'pt/api/BackOfficeUsers/MoveTransferQuarantine',
  approveReceiptNfe: 'pt/api/ReceiptsNfe/ValidateReceiptNfe/',
  deleteReceiptNfe: 'pt/api/ReceiptsNfe/',
  transferHierarchy: 'pt/api/TransferHierarchies/TransferHierarchy/',
  getReceiptsByHierarchies: 'pt/api/ReceiptsNfe/GetReceiptsByHierarchies/',
  getDirectDelivererWithoutPaymentOrder: 'pt/api/ManageDirectDeliverers/GetDirectDeliverersWithoutPaymentOrder',
  getShipmentsByDirectDeliverer: 'pt/api/Boardings/GetBoardingsWithoutPaymentOrder/',
  getTranshipmentsWithoutPaymentOrder: 'pt/api/ManageTranshipments/GetTranshipmentsWithoutPaymentOrder',
  getStopsWithoutPaymentOrder: 'pt/api/Stops/GetStopsWithoutPaymentOrder',
  createPaymentOrder: 'pt/api/PaymentOrders/Create',
  getStatusByRoles: 'pt/api/Status/GetStatusByRoles',
  getNfesByStatusIdForManagement: 'pt/api/Nfes/GetNfesByStatusIdForManagement',
  report: 'pt/api/Reports/NfeReport',
  getReports: 'pt/api/Reports/GetAllExportsDownload',
  downloadExport: 'pt/api/Reports/Export',
  toBeReturned: 'pt/api/BackOfficeUsers/ToBeReturned',
  getAllPaymentOrders: 'pt/api/PaymentOrders/GetAllPaymentOrders',
  payPaymentOrder: 'pt/api/PaymentOrders/Pay',
  undoPaymentOrder: 'pt/api/PaymentOrders/DeletePaymentOrder',
  getPaymentOrderDetails: 'pt/api/PaymentOrders/GetDetailsPaymentOrder',
  getSummaryTypePaymentOrder: 'pt/api/PaymentOrders/SummaryTypePaymentOrder',
  getSummaryStatusPaymentOrder: 'pt/api/PaymentOrders/SummaryStatusPaymentOrder',
  getDirectDeliverersForPaymentOrder: 'pt/api/ManageDirectDeliverers/GetDirectDeliverersForPaymentOrder',
  getTranshipmentForPaymentOrder: 'pt/api/ManageTranshipments/GetTranshipmentForPaymentOrder',
  getTranshipmentByCity: 'pt/api/ManageTranshipments/GetTranshipmentByCity?cityId=',
  getTranshipmentsCities: 'pt/api/ManageTranshipments/GetTranshipmentsCities',
  getPDFPaymentOrder: 'pt/api/PaymentOrders/getPDFPaymentOrder',
  getCargosWithoutPaymentOrders: 'pt/api/Cargos/GetCargosWithoutPaymentOrder',
  getStopsWithoutPaymentOrderByTranshipmentId: 'pt/api/Stops/GetStopsWithoutPaymentOrderByTranshipmentId',
  changeCompletionDate: 'pt/api/Nfes/ChangeCompletionDate',
  updateNfesCompletionDates: 'pt/api/Nfes/UpdateNfesCompletionDates',
  getTranshipmentsDashboardData: 'pt/api/Dashboard/GetCountNfesGeneral',
  getTranshipmentsDashboardDataByTranshipmentId: 'pt/api/Dashboard/GetCountNfesByTranshipmentId',
  getTranshipmentQuantityByTranshipmentId: 'pt/api/Dashboard/GetQuantityPerTransshipmentId',
  getTranshipmentFinancialQuantityByTranshipmentId: 'pt/api/Dashboard/GetFinancialTranshipmentId',
  getTranshipmentFinancialDataForAllTransshipments: 'pt/api/Dashboard/GetFinancialDataForAllTransshipments',
  getTranshipmentsQuantity: 'pt/api/Dashboard/GetQuantityGeneral',
  getTranshipmentEvaluationByTranshipmentId: 'pt/api/EvaluationTranshipment/GetEvaluationByTranshipmentId',
  saveTranshipmentEvaluation: 'pt/api/EvaluationTranshipment',
  getShipmentsManagementCtesOnTime: 'pt/api/Management/GetCtesOnTime',
  getShipmentsManagementCtesCriticalDay: 'pt/api/Management/GetCtesCriticalDay',
  getShipmentsManagementCtesLate: 'pt/api/Management/GetCtesLate',
  getTranshipmentsManagementCtesOnTime: 'pt/api/Management/GetDayLimitTranshiment',
  getTranshipmentsManagementCtesCriticalDay: 'pt/api/Management/GetCriticalDayTranshipment',
  getTranshipmentsManagementCtesLate: 'pt/api/Management/GetCtesLateTranshipment',
  getManageTranshipmentDeliverers: 'pt/api/ManageTranshipmentDeliverers',
  getAllAditionals: 'pt/api/Additionals/GetAllAdditionals',
  createAditionals: 'pt/api/Additionals/Create',
  deleteAditional: 'pt/api/Additionals/DeleteAdditional?additionalId=',
  editAditional: 'pt/api/Additionals/EditAdditional',
  exportAditionalSheet: 'pt/api/Additionals/ReportAdditional',
  getSenders: 'pt/api/Senders',
  getRelatedAditionals: 'pt/api/Additionals/AdditionalForBinding?userId=',
  getNfesByStopAndStatusesIds: 'pt/api/Nfes/GetNfesByStopIdWithStatus',
  getTranshipmentsWithoutNegotiation: 'pt/api/ManageTranshipments/GetAllTranshipmentWithoutNegotiation',
  negotiations: 'pt/api/Negotiations',
  getNegotiationTypes: 'pt/api/DomainEntities/TypeNegotiations',
  getSubTypeNegotiations: 'pt/api/DomainEntities/SubTypeNegotiations',
  exportPaymentOrders: 'pt/api/PaymentOrders/ReportFinancial',
  deleteShipment: 'pt/api/Boardings',
  updateDeliveryForecastDate: 'pt/api/Deliveries/ChangeForecastDeliveryDate',
  getShipperDeliveries: 'pt/api/Deliveries/GetDeliveriesShipperById',
  getShipperNfes: 'pt/api/Nfes/GetNfesShipperById',
  getShippers: 'pt/api/Senders/GetAllSenders',
  getShipper: 'pt/api/Senders',
  createShipper: 'pt/api/Senders',
  editShipper: 'pt/api/Senders',
  disableShipper: 'pt/api/Senders/Disable',
  enableShipper: 'pt/api/Senders/Enable',
  deleteShipper: 'pt/api/Senders',
  getShipperNfesFastManagement: 'pt/api/Nfes/GetNfesByDeliveryShipper',
  uploadReceiptsToBackup: 'pt/api/DownloadReceipt/UploadReceipt',
  downloadReceiptByInvoice: 'pt/api/DownloadReceipt/DownloadReceiptByInvoice?invoiceId=',
  downloadReceiptPdf: 'pt/api/DownloadReceipt/DownloadReceiptPdf?invoiceId=',
  getBackupList: 'pt/api/DownloadReceipt/GetListBackupReceipt',
  getListDownloadReceiptPdf: 'pt/api/DownloadReceipt/GetListDownloadReceiptPdf',
  downloadReceiptZip: 'pt/api/DownloadReceipt/DownloadReceiptFileZip',
  downloadReceiptPdfFile: 'pt/api/DownloadReceipt/DownloadReceiptPdfFile/',
  getAditionalsReceivable: 'pt/api/AdditionalReceivable',
  validateAccessKeyCte: 'pt/api/AdditionalReceivable/ValidateAccessKeyCte',
  createAditionalsReceivable: 'pt/api/AdditionalReceivable',
  editAditionalReceivable: 'pt/api/AdditionalReceivable',
  deleteAditionalReceivable: 'pt/api/AdditionalReceivable?additionalReceivableId=',
  deleteXmlAditionalReceivable: 'pt/api/AdditionalReceivable/RemoveXml?additionalReceivableId=',
  downloadXmlAditionalReceivable: 'pt/api/AdditionalReceivable/DownloadXml?additionalReceivableId=',
  exportAditionalReceivable: 'pt/api/AdditionalReceivable/ReportAdditionalReceivable',
  getSendersWithoutInvoice: 'pt/api/Senders/GetSendersWithoutInvoice',
  getCargosWithoutInvoice: 'pt/api/Cargos/GetCargosWithoutInvoice',
  getAllDeliveriesWithoutInvoiceByCargo: 'pt/api/Deliveries/GetAllDeliveriesWithoutInvoiceByCargo',
  getDeliveriesWithoutInvoiceByCargo: 'pt/api/Deliveries/GetDeliveriesWithoutInvoiceByCargo',
  getNfesWithoutInvoice: 'pt/api/Nfes/GetNfesWithoutInvoice',
  getAllDeliveriesWithoutInvoicesByShipperId: 'pt/api/Deliveries/GetAllDeliveriesWithoutInvoiceByShipper?shipperId=',
  getDeliveriesWithoutInvoicesByShipperId: 'pt/api/Deliveries/GetDeliveriesWithoutInvoiceByShipper',
  getRelatedAditionalsReceivableByShipper: 'pt/api/AdditionalReceivable/GetAdditionalReceivableByShipper?shipperId=',
  updateObservationCte: 'pt/api/Deliveries/UpdateObservationCte',
  getInvoicesReceivable: 'pt/api/Invoice',
  createInvoice: 'pt/api/Invoice',
  updateInvoiceReceivable: 'pt/api/Invoice/UpdateStatusForPaymentReceived',
  undoInvoice: 'pt/api/Invoice/UndoInvoice?invoiceId=',
  getDetailsInvoice: 'pt/api/Invoice/GetDetailsInvoice?invoiceId=',
  getInvoicesByShipper: 'pt/api/Invoice/GetAllByShipper',
  approveInvoiceByShipper: 'pt/api/Invoice/ApproveInvoice?invoiceId=',
  rejectInvoiceByShipper: 'pt/api/Invoice/RejectInvoice',
  reportInvoice: 'pt/api/Invoice/ReportInvoice',
  reportInvoiceByShipper: 'pt/api/Invoice/ReportInvoiceByShipper',
  downloadPDFInvoice: 'pt/api/Invoice/DownloadPDFInvoice?invoiceId=',
  getInvoiceStatus: 'pt/api/DomainEntities/InvoiceStatus',
  getAllManualBoarding: 'pt/api/ManualBoardingImport/GetAll',
  getSummaryManualBoardingSteps: 'pt/api/DomainEntities/ManualBoardingImportSteps',
  createManualBoardingImport: 'pt/api/ManualBoardingImport',
  startManualBoardingImport: 'pt/api/ManualBoardingImport/StartManualBoardingImport?manualBoardingImportId=',
  getByIdManualBoardingImport: 'pt/api/ManualBoardingImport/GetById/',
  deleteManualBoardingImport: 'pt/api/ManualBoardingImport/DiscardManualBoardingImportProcess?manualBoardingImportId=',
  uploadNfeXml: 'pt/api/ManualBoardingImport/UploadXmlsNfe',
  getAllXmlsNfe: 'pt/api/ManualBoardingImport/GetAllXmlsNfe?manualBoardingImportId=',
  deleteXmlNfe: 'pt/api/ManualBoardingImport/HistoryXmlNfe',
  deleteMultipleUnusedNfes: 'pt/api/NfesTemp/DeleteMultipleUnusedNfes',
  getQuantityXmlsNfeStatus: 'pt/api/ManualBoardingImport/GetQuantityXmlsNfeStatus?manualBoardingImportId=',
  updateManualBoardingSteps: 'pt/api/ManualBoardingImport/StepsUpdate?manualBoardingImportId=',
  confirmImportsNfes: 'pt/api/ManualBoardingImport/ConfirmImportsNfes?manualBoardingImportId=',
  getUnallocatedNfesManualBoarding: 'pt/api/NfesTemp/GetUnallocatedNfes?manualBoardingImportId=',
  createDeliveryManualBoarding: 'pt/api/DeliveriesTemp/Add?manualBoardingImportId=',
  createGroupedDeliveries: 'pt/api/DeliveriesTemp/CreateGroupedDeliveries?manualBoardingImportId=',
  deleteDeliveryManualBoarding: 'pt/api/DeliveriesTemp/DeleteDelivery?deliveryId=',
  deleteMultipleDeliveryManualBoarding: 'pt/api/DeliveriesTemp/DeleteMultipleDeliveries',
  getDeliveriesManualBoarding: 'pt/api/DeliveriesTemp/GetAll?manualBoardingImportId=',
  getCtesManualBoarding: 'pt/api/DeliveriesTemp/GetDeliveriesWithCtes?manualBoardingImportId=',
  updateDeliveriesDetailsData: 'pt/api/DeliveriesTemp/UpdateDeliveriesDetailsData',
  allocateNfesManualBoarding: 'pt/api/DeliveriesTemp/AllocateNfes?deliveryId=',
  deallocateNfesManualBoarding: 'pt/api/DeliveriesTemp/DeallocateNfes?deliveryId=',
  getNfesByDeliveryIdManualBoarding: 'pt/api/NfesTemp/GetNfesByDeliveryId?deliveryId=',
  createGroupedStops: 'pt/api/StopsTemp/CreateGroupedStops?manualBoardingImportId=',
  getUnallocatedDeliveries: 'pt/api/DeliveriesTemp/GetUnallocatedDeliveries?manualBoardingImportId=',
  getStopsManualBoarding: 'pt/api/StopsTemp/GetAll?manualBoardingImportId=',
  createStopManualBoarding: 'pt/api/StopsTemp/Add?manualBoardingImportId=',
  deleteStopManualBoarding: 'pt/api/StopsTemp/DeleteStop?stopId=',
  deleteMultipleStopsManualBoarding: 'pt/api/StopsTemp/DeleteMultipleStops',
  allocateDeliveriesManualBoarding: 'pt/api/StopsTemp/AllocateDeliveries?stopId=',
  deallocateDeliveriesManualBoarding: 'pt/api/StopsTemp/DeallocateDeliveries?stopId=',
  getDeliveriesByStopIdManualBoarding: 'pt/api/DeliveriesTemp/GetDeliveriesByStopId?stopId=',
  getUnallocatedStops: 'pt/api/StopsTemp/GetUnallocatedStops?manualBoardingImportId=',
  getCargosManualBoarding: 'pt/api/CargosTemp/GetAll?manualBoardingImportId=',
  createCargoManualBoarding: 'pt/api/CargosTemp/Add?manualBoardingImportId=',
  createGroupedCargos: 'pt/api/CargosTemp/CreateGroupedCargo?manualBoardingImportId=',
  deleteCargoManualBoarding: 'pt/api/CargosTemp/DeleteCargo?cargoId=',
  deleteMultipleCargosManualBoarding: 'pt/api/CargosTemp/DeleteMultipleCargos',
  getStopsByCargoIdManualBoarding: 'pt/api/StopsTemp/GetStopsByCargoId?cargoId=',
  allocateStopsManualBoarding: 'pt/api/CargosTemp/AllocateStops?cargoId=',
  deallocateStopsManualBoarding: 'pt/api/CargosTemp/DeallocateStops?cargoId=',
  getUnallocatedCargos: 'pt/api/CargosTemp/GetUnallocatedCargos?manualBoardingImportId=',
  getBoardingsManualBoarding: 'pt/api/BoardingsTemp/GetAll?manualBoardingImportId=',
  createBoardingManualBoarding: 'pt/api/BoardingsTemp/Add?manualBoardingImportId=',
  updateBoardingManualBoarding: 'pt/api/BoardingsTemp/Update?id=',
  createGroupedBoarding: 'pt/api/BoardingsTemp/CreateGroupedCargo?manualBoardingImportId=',
  getCargosByBoardingIdManualBoarding: 'pt/api/CargosTemp/GetCargosByBoardingId?boardingId=',
  allocateCargosManualBoarding: 'pt/api/BoardingsTemp/AllocateCargos?boardingId=',
  deallocateCargosManualBoarding: 'pt/api/BoardingsTemp/DeallocateCargos?boardingId=',
  deleteBoardingManualBoarding: 'pt/api/BoardingsTemp/DeleteBoarding?boardingId=',
  deleteMultipleBoardingsManualBoarding: 'pt/api/BoardingsTemp/DeleteMultipleBoardings',
  getQuantitiesNfesAndDeliveriesByCity:
    'pt/api/DashboardManualImport/GetQuantitiesNfesAndDeliveriesByCityAndSender?manualBoardingImportId=',
  getQuantitiesNfesAndDeliveriesBySender:
    'pt/api/DashboardManualImport/GetQuantitiesNfesAndDeliveriesBySender?manualBoardingImportId=',
  getQuantitiesHierarchyRecords: 'pt/api/DashboardManualImport/GetQuantitiesHierarchyRecords?manualBoardingImportId=',
  getUnusedNfes: 'pt/api/NfesTemp/GetUnusedNfes',
  uploadXml: 'pt/api/CteUploadXmls',
  getUploadsXmls: 'pt/api/CteUploadXmls',
  getCteXmlDetails: 'pt/api/CteUploadXmls/GetDetailsCteXml?cteXmlId=',
  getAllCtes: 'pt/api/CteUploadXmls/GetAllCtes',
  downloadXmlCtes: 'pt/api/DownloadCteXml',
  getCteXmlStatus: 'pt/api/DomainEntities/CteXmldStatus',
  getDownloadCteXmls: 'pt/api/DownloadCteXml/GetListDownloadCteXml',
  downloadCteXmlsByInvoice: 'pt/api/DownloadCteXml/DownloadCteXmlsByInvoice?invoiceId=',
  downloadCteXmlFileZip: 'pt/api/DownloadCteXml/DownloadCteXmlFileZip/',
  downloadXmlCteFilters: 'pt/api/DownloadCteXml/DownloadXmlCteFilters/',
  getDetailsEmailInvoiceHistory: 'pt/api/SendEmailInvoice/GetDetailsEmailInvoiceHistory?invoiceId=',
  sendEmailInvoice: 'pt/api/SendEmailInvoice?invoiceId='
};

export const baseURL = process.env.VUE_APP_BASE_URL;

export const requestOptionsPOST = (token, body) => {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ ...body })
  };
};

export const requestOptionsPOSTwithFormData = (token, body) => {
  return {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: body
  };
};

export const requestOptionsPOSTWithoutBody = (token) => {
  return {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};

export const requestOptionsPOSTForFiles = (token) => {
  return {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Response-Type': 'APPLICATION/octet-stream'
    }
  };
};

export const requestOptionsPOSTWithArrayBody = (token, body) => {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(body)
  };
};

export const requestOptionsGET = (token) => {
  return {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};

export const requestOptionsPUT = (token) => {
  return {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};

export const requestOptionsPUTWithBody = (token, body) => {
  return {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ ...body })
  };
};

export const requestOptionsPUTWithArrayBody = (token, body) => {
  return {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(...body)
  };
};

export const requestOptionsDELETE = (token) => {
  return {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};

export const requestOptionsDELETEWithArrayBody = (token, body) => {
  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(body)
  };
};

export const requestOptionsDELETEWithBody = (token, body) => {
  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ ...body })
  };
};
